import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './index.css';

// One-time listing seed so a freshly provisioned database isn't empty on
// first load. Guarded server-side (server/routes/index.ts /api/dev/seed) —
// it's a no-op once the `listings` table has any row, so this is safe to
// fire on every page load.
void fetch('/api/dev/seed', {method: 'POST'}).catch(() => undefined);

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
